export default __webpack_public_path__ + "static/media/DStack.c4987145.png";